import { Injectable } from '@angular/core';

declare function require(module: string): any;
const {bb} = require('billboard.js'); // import a module with no types


export class AngularBillboardService {
    
    generate(...data: any[]) {
        return data.map((options: any) => bb.generate(options));
    }
static decorators: DecoratorInvocation[] = [
{ type: Injectable },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
